/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flight-category[_ngcontent-%COMP%]{box-sizing:border-box;background:#777;color:#fff;min-width:64px;padding:8px 12px;font-size:12px;text-align:center}.flight-category--vfr[_ngcontent-%COMP%]{background:#0a3}.flight-category--mvfr[_ngcontent-%COMP%]{background:#00e}.flight-category--ifr[_ngcontent-%COMP%]{background:red}.flight-category--lifr[_ngcontent-%COMP%]{background:#c3f}"];
export { styles as styles };
